import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UiState {
    sidebarOpen: boolean;
    sidebarCollapsed: boolean;
    darkMode: boolean;
}

const initialState: UiState = {
    sidebarOpen: true,
    sidebarCollapsed: false,
    darkMode: localStorage.getItem('darkMode') === 'true',
};

const uiSlice = createSlice({
    name: 'ui',
    initialState,
    reducers: {
        toggleSidebar: (state) => {
            state.sidebarOpen = !state.sidebarOpen;
        },
        setSidebarOpen: (state, action: PayloadAction<boolean>) => {
            state.sidebarOpen = action.payload;
        },
        toggleSidebarCollapsed: (state) => {
            state.sidebarCollapsed = !state.sidebarCollapsed;
        },
        toggleDarkMode: (state) => {
            state.darkMode = !state.darkMode;
            localStorage.setItem('darkMode', String(state.darkMode));
        },
    },
});

export const { toggleSidebar, setSidebarOpen, toggleSidebarCollapsed, toggleDarkMode } =
    uiSlice.actions;
export default uiSlice.reducer;
